const initialState = {
    userLoggedIn: false,
    credentials: null,

    authError: null,
    jwtToken: null,

    asideBg: false,
    asideColapsed: false,
    asideToggled: false,
    darkTheme: false,

    role: "client",
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };
    switch (action.type) {
        case "USER_MAP_ROLE":
            return {
                ...state,
                role: action.data,
            };

        case "USER_MAP_CREDENTIALS":
            return {
                ...state,
                credentials: action.data,
            };

        case "USER_LOG_IN":
            return {
                ...state,
                userLoggedIn: true,
            };

        case "USER_LOG_OUT":
            return {
                ...state,
                userLoggedIn: false,
            };

        case "USER_MAP_JWT":
            return {
                ...state,
                jwtToken: action.data,
            };

        case "LOGIN_ERROR":
            return {
                ...state,
                authError: "Neuspjela prijava",
            };

        case "LOGIN_SUCCESS":
            return {
                ...state,
                authError: null,
            };

        case "DARK_THEME_TOGGLER":
            return {
                ...state,
                darkTheme: !state.darkTheme,
            };

        case "ASIDE_TOGGLER":
            return {
                ...state,
                asideToggled: action.data,
            };
        case "ASIDE_COLAPSED":
            return {
                ...state,
                asideColapsed: !state.asideColapsed,
            };

        case "ASIDE_BG":
            return {
                ...state,
                asideBg: !state.asideBg,
            };

        default:
        // do ntohing
    }
    return newState;
};

export default reducer;
